import { FC } from 'react'

import { SpecialCondition } from '@/screens/Product/page/types/types'

import { ProductServiceCard } from '@/features/product-services/ui/ProductServiceCard/ProductServiceCard'

import { Modal } from '@/shared/ui'

import cls from './CardModal.module.scss'

type CardModalContentProps = {
	isOpen: boolean
	items: SpecialCondition[`productList`]
	onApply?: (id: number) => void
	onClose?: () => void
}

export const CardModal: FC<CardModalContentProps> = ({ items, onApply, isOpen, onClose }) => (
	<Modal isOpen={isOpen} onClose={onClose} contentClassName={cls.modalContent}>
		<div className={cls.cardModalContent__inner}>
			{items.map(item => (
				<>
					<ProductServiceCard
						{...item}
						key={item.NAME}
						ID={item.ID}
						DETAIL_PICTURE={item.IMAGE}
						count={1}
						price={item.PRICE}
						bonusScore={0}
						maxCount={1}
						onApply={onApply}
						PRODUCT_ID={item.PRODUCT_ID}
						TITLE={item.NAME || item.TITLE || ``}
						KOD={item.ID}
					/>
				</>
			))}
		</div>
	</Modal>
)
